import { Component, ViewChild, OnInit, AfterViewInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';

import { MatCardModule } from '@angular/material/card';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonModule } from '@angular/material/button';

import { AppService } from '@app/app.service';
import { LoadingOverlayService } from '@app/shared/loading-overlay/loading-overlay.service';
import { MatDialog } from '@angular/material/dialog';
import { TicketViewDialogComponent } from './ticket-view-dialog/ticket-view-dialog.component';

@Component({
  selector: 'app-tickets',
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatIconModule,
    MatTooltipModule,
    MatButtonModule,
  ],
  templateUrl: './tickets.html',
  styleUrl: './tickets.scss',
})
export class Tickets implements OnInit, AfterViewInit {

  displayedColumns: string[] = [
    'actions',
    'reference_id',
    'type',
    'resolved_at',
    'subject',
    'user',
    'age_human',
  ];

  dataSource = new MatTableDataSource<any>([]);

  @ViewChild(MatSort) sort?: MatSort;
  @ViewChild(MatPaginator) paginator?: MatPaginator;

  constructor(
    private appService: AppService,
    private loadingOverlay: LoadingOverlayService,
    private router: Router,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.dataSource.sortingDataAccessor = (item: any, property: string) => {
      switch (property) {
        case 'type':
          return item.type ?? '';

        case 'subject':
          return item.subject ?? '';

        case 'user':
          return item.user?.name ??
            `${item.user?.first_name ?? ''} ${item.user?.last_name ?? ''}`;

        case 'created_at':
          return item.created_at ?? '';

        case 'resolved_at':
          return item.resolved_at ?? '';

        case 'age_human':

          return item.age ?? 0;

        default:
          return item[property] ?? '';
      }
    };

    this.getTickets();
  }

  ngAfterViewInit(): void {
    this.dataSource.sort = this.sort ?? null;
    this.dataSource.paginator = this.paginator ?? null;
  }

  getTickets(): void {
    this.loadingOverlay.show();

    this.appService.getTickets().subscribe({
      next: (res) => {
        this.dataSource.data = res.data ?? res ?? [];
        this.loadingOverlay.hide();
      },
      error: (err) => {
        this.loadingOverlay.hide();

        this.appService.errorSnackBar(
          err?.error?.message ?? 'Failed to load tickets'
        );
      },
    });
  }

  getUserName(user: any): string {
    if (!user) return 'N/A';

    if (user.name) return user.name;

    const fullName =
      `${user.first_name ?? ''} ${user.last_name ?? ''}`.trim();

    return fullName || 'N/A';
  }

  openTicketDetails(ticket: any): void {
    this.dialog.open(TicketViewDialogComponent, {
      width: '500px',
      data: ticket,
    });
  }

  goBack(): void {
    this.router.navigate(['/dashboard']);
  }
}